module.exports = __webpack_public_path__ + "img/bitab-1.6d5dc8f1.png";